import { render } from "./messageCardAppointment.vue?vue&type=template&id=1c3a9a94&scoped=true"
import script from "./messageCardAppointment.vue?vue&type=script&lang=js"
export * from "./messageCardAppointment.vue?vue&type=script&lang=js"

import "./messageCardAppointment.vue?vue&type=style&index=0&id=1c3a9a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3a9a94"]])

export default __exports__